import React from "react";

const TeamLogo = ({ abbr }: { abbr: string }) => {
  const isValid = /^[A-Z0-9]+$/.test(abbr);
  const safeAbbr = isValid ? abbr : "ZEBRA";

  const [src, setSrc] = React.useState(`/assets/images/logos/${safeAbbr}.svg`);

  return (
    <img
      src={src}
      alt={safeAbbr}
      width="22px"
      onError={() => {
        setSrc((prev) =>
          prev.endsWith(".png") ? prev : `/assets/images/logos/${safeAbbr}.png`
        );
      }}
    />
  );
};
export default TeamLogo;
